import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function StringEditWithConfirmation({
  value,
  onModified,
}: {
  value: string | null | undefined;
  onModified: (newValue: string) => void;
}) {
  const [currentString, setCurrentString] = useState<string>(value || '');
  const [isModified, setIsModified] = useState(false);

  function update() {
    const newStringValue = currentString;
    onModified(newStringValue);
    setIsModified(false);
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        boxSizing: 'border-box',
        background: isModified ? 'rgba(255,200,0,0.25)' : undefined,
      }}
    >
      <input
        type="text"
        style={{
          width: '100%',
          boxSizing: 'border-box',
        }}
        value={isModified ? currentString : value || ''}
        onChange={(ev) => {
          const newStringValue = ev.target.value;
          setIsModified(true);
          setCurrentString(newStringValue);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') update();
        }}
      />
      {isModified && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            right: '3px',
            color: 'red',
          }}
          onClick={(ev) => update()}
        >
          <FontAwesomeIcon icon="check" />
        </div>
      )}
    </div>
  );
}
